import { useCallback, useEffect } from 'react';
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { getNotificationSettings } from '../../services/settingsService';
import { apiParamsState } from '../../storage/app';
import {
  editingNotificationSettingsState,
  loadingNotificationSettingsState,
  notificationSettingsState,
  updateNotificationSettingsState,
} from '../../storage/settings';
import useUpdateEffect from '../../hooks/useUpdateEffect';

function NotificationSettingsProvider() {
  const apiParams = useRecoilValue(apiParamsState);
  const setNotificationSettings = useSetRecoilState(notificationSettingsState);
  const updateNotificationSettings = useRecoilValue(updateNotificationSettingsState);
  const resetUpdateNotificationSettings = useResetRecoilState(updateNotificationSettingsState);
  const resetEditingNotificationSettings = useResetRecoilState(editingNotificationSettingsState);
  const setLoadingNotificationSettings = useSetRecoilState(loadingNotificationSettingsState);

  const loadNotificationSettings = useCallback(async () => {
    const invalid = !apiParams?.clientId || !apiParams?.subClientId;
    if (invalid) return;

    const { notificationSettings, error } = await getNotificationSettings(apiParams.clientId, apiParams.subClientId);
    if (!error && notificationSettings) {
      setNotificationSettings(notificationSettings);
    } else {
      setNotificationSettings(undefined);
    }
  }, [apiParams?.clientId, apiParams?.subClientId, setNotificationSettings]);

  useEffect(() => {
    setLoadingNotificationSettings(true);
    loadNotificationSettings().finally(() => {
      setLoadingNotificationSettings(false);
    });
  }, [apiParams?.clientId, apiParams?.subClientId, setLoadingNotificationSettings, loadNotificationSettings]);

  useUpdateEffect(() => {
    if (!updateNotificationSettings) return;

    loadNotificationSettings().finally(() => {
      resetUpdateNotificationSettings();
      resetEditingNotificationSettings();
    });
  }, [updateNotificationSettings]);

  return null;
}

export default NotificationSettingsProvider;
